import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import NotFoundImage from 'assets/images/404-illustration.svg';
import { Button } from 'components/commons';
import {Loader} from "./";
import {withParamsFrame} from "../HOCs";

interface IPageNotFoundProps {
  params: string
  error?: string | number
}

const PageNotFound: React.FC<IPageNotFoundProps> = ({ params, error }) => {
  const [loaded, setLoaded] = React.useState(false);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [isPageExists, setIsPageExists] = useState(false);
  const [foundPageSrc, setFoundPageSrc] = useState("");

  const { t } = useTranslation();

  useEffect(() => {
    const path = window.location.pathname.replace('/a', '');
    const iframeSrc = `https://lk.market${path}${params}`;

    (async function() {
      try {
        setIsPageLoading(true);
        const res = await fetch(iframeSrc);
        if(!res.ok) {
          throw new Error("Page not found")
        }
        setIsPageExists(true);
        setFoundPageSrc(iframeSrc);
      } catch (error) {
        setIsPageExists(false);
        setFoundPageSrc("");
      } finally {
        setIsPageLoading(false);
      }
    })();
  }, [])

  if(isPageLoading) {
    return <Loader />
  }

  if(isPageExists && foundPageSrc) {
    return (
      <>
        <div className='xs:mx-3'>
          <iframe className={`${!loaded ? 'min-h-[auto]' : 'min-h-[93vh]'}`} src={`${foundPageSrc}`}
                    title="Products"
                    width="100%"
                    height={`${loaded ? "calc(100vh-64px)" : "0px"}`}
                    onLoad={() => setLoaded(true)}
            ></iframe>
          </div>
          {
              !loaded && <Loader/>
          }
      </>
    )
  }

  return (
    <div className="flex h-screen overflow-hidden">
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden bg-white">
        <main>
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="max-w-2xl m-auto mt-16">
              <div className="text-center px-4">
                <div className="inline-flex mb-8">
                  <img src={NotFoundImage} width="176" height="176" alt="404 illustration"/>
                </div>
  
                {(error === 403) ? (<div className="mb-6">{t("page 403", {ns: "messages"})}</div>) : (
                    <div className="mb-6">{t("page 404", {ns: "messages"})}</div>)}
                {(error !== 403) && (
                    <Button appearance="primary">
                      <Link to="/">{t("Back to dashboard", {ns: "messages"})}</Link>
                    </Button>
                )}
              </div>
            </div>
          </div>
        </main>
                  
      </div>
    </div>
  );

}

export default withParamsFrame(PageNotFound);